export const MIN_DURATION_MINUTES = 0;
export const MAX_DURATION_MINUTES = 240;
export const DURATION_STEP_MINUTES = 1;
export const DURATION_MAX_LENGTH = 3;
